import {Box} from '@mui/material';
import PopUp from 'components/PopUp/PopUp';
import React from 'react';

type responseProps = {
  title: string;
  message: React.ReactElement;
  open: boolean;
  confirm: () => void;
};
const ResponsePopup = ({open, confirm, message, title}: responseProps) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    confirm();
  };
  return (
    <PopUp title={title} open={open} confirmText='Close' onConfirm={() => confirm()} width='520px' maxWidth='sm'>
      <Box sx={{pb: '20px'}} component='form' onSubmit={handleSubmit}>
        {message}
      </Box>
    </PopUp>
  );
};
export default ResponsePopup;
